<template>
  <div v-if="blockInfo">
    <template v-for="(item, index) in blockInfo.ads">
      <AdRenderer
        v-if="showCondition(item, parentIndex)"
        :key="unit + index + item.componentInfo.type"
        v-bind="{ ...item.componentInfo, ...$attrs }"
      ></AdRenderer>
    </template>
  </div>
</template>
<script>
import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import AdRenderer from '@/modules/ads/components/AdRenderer';
import { useDevice } from '@/composables/useDevice';
import { adBlocks } from '../constants/blocks/blocks';
export default defineComponent({
  props: {
    unit: {
      type: String,
      required: true,
    },
    parentIndex: {
      type: Number,
    },
  },
  components: {
    AdRenderer,
  },
  setup(props) {
    const { isMobile } = useDevice();
    const adConfig = inject('adConfig');
    const blockInfo = computed(() => {
      const type = adConfig.value?.type;
      const onlyMasthead = adConfig.value?.onlyMasthead;
      const device = isMobile.value ? 'mobile' : 'desktop';
      let block;
      if (onlyMasthead && props.unit === 'masthead') {
        block = adBlocks?.[type]?.[device]?.[props.unit];
      } else if (!onlyMasthead) {
        block = adBlocks?.[type]?.[device]?.[props.unit];
      }
      if (block) {
        if (block.showAt) {
          for (let i = 0; i < block.showAt.length; i++) {
            if (Number.isFinite(block.showAt[i])) {
              if (block.showAt[i] === props.parentIndex) {
                return block;
              } else {
                continue;
              }
            } else {
              const fnResult = block.showAt[i](props.parentIndex);
              if (fnResult) return block;
            }
          }
        } else {
          return block;
        }
      }
    });
    const showCondition = (adUnit, index) => {
      const showState = {
        scriptLoaded: false,
        isAllowed: true,
        referralState: true,
      };
      if (adConfig.value?.mode?.scripts) {
        const scripts = adConfig.value.mode.scripts;
        for (let i = 0; i <= scripts.length; i++) {
          const scriptType = Array.isArray(scripts[i]) ? scripts[i][0] : scripts[i];
          if (adUnit.componentInfo.type === scriptType) {
            showState.scriptLoaded = true;
            break;
          } else {
            showState.scriptLoaded = false;
          }
        }
      }
      const allowedAdUnits = adConfig.value?.mode?.allowedAdUnits;
      const ignoredAdUnits = adConfig.value?.mode?.ignoredAdUnits;
      const device = isMobile.value ? 'mobile' : 'desktop';

      if (allowedAdUnits) {
        if (Object.keys(allowedAdUnits).includes(adUnit.componentInfo.type)) {
          showState.isAllowed = adConfig.value.mode.allowedAdUnits[adUnit.componentInfo.type][device].includes(
            adUnit.componentInfo['unit-name']
          );
        } else {
          showState.isAllowed = true;
        }
      }

      if (ignoredAdUnits) {
        if (Object.keys(ignoredAdUnits).includes(adUnit.componentInfo.type)) {
          showState.isAllowed = !adConfig.value.mode.ignoredAdUnits[adUnit.componentInfo.type][device].includes(
            adUnit.componentInfo['unit-name']
          );
        } else {
          showState.isAllowed = true;
        }
      }

      const renderConditions = adUnit.condition;
      if (renderConditions) {
        if (renderConditions.show) {
          if (adConfig.value?.type === 'Article' && adConfig.value.fetchData) {
            const { legacyId, tags, categories } = adConfig.value.fetchData?.value;
            const mainCategory = categories[0]?.name || '';
            if (renderConditions.show.articleId?.length) {
              showState.isAllowed = renderConditions.show.articleId.includes(legacyId);
            }
            if (renderConditions.show.categoryName?.length) {
              showState.isAllowed = renderConditions.show.categoryName.includes(mainCategory);
            }
            if (renderConditions.show.tagName?.length) {
              showState.isAllowed = tags.some((tag) => tag.includes(renderConditions.show.tagName));
            }
          }
        }
        if (renderConditions.hide) {
          if (adConfig.value?.type === 'Article' && adConfig.value.fetchData) {
            const { legacyId, tags, categories } = adConfig.value.fetchData?.value;
            const mainCategory = categories[0]?.name || '';
            if (renderConditions.hide.tagName?.length) {
              showState.isAllowed = !tags.some((tag) => tag.includes(renderConditions.hide.tagName));
            }
            if (renderConditions.hide.categoryName?.length) {
              showState.isAllowed = !renderConditions.hide.categoryName.includes(mainCategory);
            }
            if (renderConditions.hide.articleId?.length) {
              showState.isAllowed = !renderConditions.hide.articleId.includes(legacyId);
            }
          }
        }
      }

      if (adUnit.showAt !== undefined) {
        if (Number.isFinite(adUnit.showAt)) {
          showState.isConditionalShow = props.parentIndex === adUnit.showAt;
        } else {
          showState.isConditionalShow = adUnit.showAt(index);
        }
      }
      return (
        showState.scriptLoaded &&
        (showState.isConditionalShow !== undefined ? showState.isConditionalShow : true) &&
        showState.isAllowed &&
        showState.referralState
      );
    };
    return { blockInfo, showCondition };
  },
});
</script>
